import { useApp } from 'contexts/app';
import { createContext, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const PageContext = createContext();

const PageProvider = (props) => {
    const { currentAssignmentId, currentAssignment, studentSubmissions } = useApp();
    const location = useLocation();
    const history = useHistory();

    const [viewFormativeDialog, setViewFormativeDialog] = useState({ open: false, submissionId: '' });

    const currentStudentSubmissions = useMemo(() => {
        const targetOwnerAccountId = new URLSearchParams(location.search).get('owner_account_id');
        return studentSubmissions?.filter(({ owner_account_id }) => owner_account_id === targetOwnerAccountId);
    }, [location.search, studentSubmissions]);

    const onClickBack = () => {
        const params = new URLSearchParams({ type: 'formative' });
        history.push(`/assignments/${currentAssignmentId}/submissions?${params.toString()}`);
    };

    const onClickViewSubmission = (submissionId) => {
        history.push(`/assignments/${currentAssignmentId}/submissions/${submissionId}`);
    };

    const onClickViewFormative = (submissionId) => {
        setViewFormativeDialog({ open: true, submissionId });
    };

    return (
        <PageContext.Provider
            value={{
                currentAssignment,
                currentStudentSubmissions,
                viewFormativeDialog,
                setViewFormativeDialog,

                onClickBack,
                onClickViewSubmission,
                onClickViewFormative,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
